// extracted by mini-css-extract-plugin
export var arrows = "scroll-arrow-module--arrows--c204b";
export var rightArrow = "scroll-arrow-module--rightArrow--864cd";